module.exports = __webpack_public_path__ + "media/images/emblems/Gemeindewappen-Brig-Glis-185bf02be4270be6ae9c865d0fe972e6.gif";